import { Avatar, Button, Dropdown, message, Space, Tabs, TabsProps, Tag } from 'antd'
import { ReactNode, useEffect, useMemo, useState } from 'react'
import BackIcon from '../../components/icons/BackIcon'
import { STATUS_ACTIVATED, STATUS_APPROVED, TAB_ASSETS, TAB_INFO, TAB_MARKETS, TAB_PRODUCTS } from '../../constants/constants';
import LinkedinIcon from '../../components/icons/LinkedinIcon';
import FacebookIcon from '../../components/icons/FacebookIcon';
import BrandInfo from './components/BrandInfo';
import { avatarBg, formatAmount } from '../../common/helpers';
import RightArrowIcon from '../../components/icons/RightArrowIcon';
import MatketPreferences from './components/MatketPreferences';
import Products from './components/Products';
import ThreeDotsIcon from '../../components/icons/ThreeDotsIcon';
import DeleteModal from './components/DeleteModal';
import { getAllOrgBrands, GetBrand, GetOrgBrands, SoftDeleteBrand, UpdateBrandStatus } from '../../API/endpoints/Brands';
import { GetOrg } from '../../API/endpoints/Organization';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Spinner from './components/Spinner';
import { Link } from 'react-router-dom';
import NavBar from '../components/header/NavBar';
import { GetUserProfile } from '../../API/endpoints/User';
import Cookies from 'js-cookie';
import Assets from './components/Assets';
import ConfirmModal from './components/ConfirmModal';
import AddEditProductAssetModal from './components/modals/AddEditProductAssetModal';
import LinkIcon from '../../components/icons/LinkIcon';
import { useBrandTabsContext } from './contexts/BrandTabsContext';
import TwitterIcon from '../../components/icons/TwitterIcon';
import InstagramIcon from '../components/BrandsPartnerComponents/InstagramIcon';

const OrganizationBrands = () => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [messageApi, contextHolder] = message.useMessage()
  const { activeTab, setActiveTab, setProductID } = useBrandTabsContext();

  const [activeBrand, setActiveBrand] = useState("");
  const [isDeleteItem, setIsDeleteItem] = useState<any>({});

  const [userProfile, setUserProfile] = useState<any>({});
  const [userID, setUserID] = useState<string | undefined>("");

  const [brands, setBrands] = useState<any>([]);
  const [orgDetails, setOrgDetails] = useState<any>({});
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);

  const [confirmApprove, setConfirmApprove] = useState(false);
  const [isAddAsset, setIsAddAsset] = useState(false);
  const [reloadAssets, setReloadAssets] = useState(false);

  const [brandDetails, setBrandDetails] = useState<any>({});
  const [brandLoading, setBrandLoading] = useState(true);


  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);


  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID]);

  useEffect(() => {


    const queryParams = new URLSearchParams(location.search);
    const brand = queryParams.get('brand');
    if (brand) {
      setActiveBrand(brand)
      setProductID("")
    }
  }, [location])

  useEffect(() => {
    if (params?.orgid) {
      fetchData();
    }
  }, [params?.orgid, reload]);

  useEffect(() => {
    if (activeBrand) {
      getBrandData();
    } else {
      setBrandDetails({})
      setBrandLoading(false);
    }
  }, [activeBrand]);

  useEffect(() => {
    if (brands?.length > 0 && activeBrand == "") {
      setActiveBrand(brands[0]?.id)
    }
  }, [brands, activeBrand])

  const getBrandData = () => {
    setBrandLoading(true);
    GetBrand(activeBrand).then((res: any) => {
      setBrandDetails(res?.data)
      setBrandLoading(false);
    }).catch((err) => {
      setBrandDetails({})
      setBrandLoading(false);
    });
  }


  const fetchData = async () => {
    try {
      setLoading(true);
      const [brandsRes, orgRes] = await Promise.all([
        GetOrgBrands(params?.orgid),
        GetOrg(params?.orgid),
      ]);
      setBrands(brandsRes?.data?.rows);
      setOrgDetails(orgRes?.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setLoading(false);
    }
  }

  const onConfirmApprove = () => {
    UpdateBrandStatus(brandDetails?.id, STATUS_APPROVED).then((res) => {
      setBrandDetails((prev: any) => ({
        ...prev,
        status: STATUS_APPROVED
      }))

      const currBrands = [...brands];
      const index = brands.findIndex((item: any) => item?.id === brandDetails?.id)
      if (index > -1) {
        currBrands[index] = {
          ...currBrands[index],
          status: STATUS_APPROVED
        }
      }
      setBrands([...currBrands])
      setConfirmApprove(false)
      messageApi.success(`${brandDetails?.brand_name} is approved successfully`)
    }).catch((err) => {
      console.log("err", err);

    })
  }

  const onSuccessDeleteBrand = () => {
    messageApi.success("Brand data deleted successfully");
    const newBrands = brands.filter((item: any) => item?.id !== isDeleteItem?.id)
    setBrands([...newBrands])
    setActiveBrand(newBrands?.[0]?.id || "")

    setIsDeleteItem({});
  }

  const onSuccessAddAsset = (data: any) => {
    messageApi.success("File requested successfully");
    setIsAddAsset(false);
    setReloadAssets(!reloadAssets)
  }

  const onCancelAddAsset = () => {
    setIsAddAsset(false);
  }


  const onChangeTab = (tab: string) => {
    setActiveTab(tab)
    setProductID("")
  }

  const openLink = (link: string) => {
    if (link) {
      const fullUrl = link.startsWith("http") ? link : `https://${link}`;
      window.open(fullUrl, "_blank", "noopener,noreferrer");
    }
  }

  const setCurrentUrl = (id: string) => {
    const params = new URLSearchParams(location.search);
    params.set('brand', id);
    navigate(`${location.pathname}?${params.toString()}`);
  }


  const actionOptions = useMemo(() => {
    let items: any = [];
    items.push(
      {
        key: '1',
        label: "Edit brand data",
        onClick: () => {
          navigate(`/editOrgBrand/${params?.orgid}/${brandDetails?.id}`)
        }
      }
    )

    items.push({
      key: '2',
      danger: true,
      label: "Delete brand data",
      onClick: () => setIsDeleteItem(brandDetails)
    })

    return items;
  }, [brandDetails])



  const items: TabsProps['items'] = useMemo(() => ([
    {
      key: TAB_INFO,
      label: 'Info',
      children: <BrandInfo data={brandDetails} />,
    },
    {
      key: TAB_MARKETS,
      label: 'Market Preferences',
      children: <MatketPreferences brandId={brandDetails?.id} />,
    },
    {
      key: TAB_PRODUCTS,
      label: 'Products',
      children: <Products brand={brandDetails} />,
    },
    {
      key: TAB_ASSETS,
      label: 'Assets',
      children: <Assets brand={brandDetails} reload={reloadAssets} />,
    },
  ]), [brandDetails, reloadAssets]);

  const brandList = useMemo(() => {
    return brands.map((brand: any) => {
      return (
        <div key={brand?.id} className={`${activeBrand === brand?.id ? "bg-[#D1E9FF]" : ""} flex items-center justify-between px-[10px] py-[8px] rounded-[4px] cursor-pointer`} onClick={() => {
          setActiveBrand(brand?.id)
          setProductID("")
          setCurrentUrl(brand?.id)
        }}>
          <div>
            <p className={`break-all ${activeBrand === brand?.id ? "text-[#1849A9]" : ""} text-[13px] font-[500] m-0`}>{brand?.brand_name}</p>
            {
              brand?.status !== STATUS_APPROVED ? (
                <Tag className='mt-[6px] capitalize rounded-[12px] font-[500]' bordered={false} color={brand?.status === STATUS_APPROVED ? 'success' : orgDetails?.is_active ? 'purple' : 'blue'}>{brand?.status === STATUS_APPROVED ? "Approved" : orgDetails?.is_active ? "Activated" : brand?.status?.toLowerCase()}</Tag>

              ) : (
                <></>
              )
            }
          </div>
          {activeBrand === brand?.id ? (
            <RightArrowIcon />
          ) : (
            <></>
          )}

        </div>
      )
    })
  }, [brands, activeBrand])


  const socialMediaLinks = useMemo(() => {
    return brandDetails?.social_media?.map((s: any) => {
      let icon: ReactNode = <></>;
      switch (s?.platform) {
        case "facebook":
          icon = <FacebookIcon />
          break;

        case "instagram":
          icon = <InstagramIcon />
          break;

        case "linkedin":
          icon = <LinkedinIcon />
          break;
        case "twitter":
          icon = <TwitterIcon />
          break;

        default:
          break;
      }
      return (
        <div onClick={() => openLink(s?.url)} className='cursor-pointer hover:scale-110 transition-all' key={s?.id}>
          {icon}
        </div>
      )
    })
  }, [brandDetails])


  const marketPlaces = useMemo(() => (
    brandDetails?.market_place?.map((m: any, index: number) => (
      <Tag key={index} bordered={false} className='bg-[#F2F4F7] font-[500] cursor-pointer hover:bg-gray-200 transition-all' onClick={() => openLink(m?.url)}>{m?.platform}</Tag>
    ))
  ), [brandDetails])

  return (
    <div className='bg-[#F2F4F7] h-full w-full'>
      {contextHolder}
      <NavBar
        prefix={
          <div className='py-[8px] flex items-center gap-x-[12px]'>
            <Button icon={<BackIcon />} type='text' className='!leading-[12px] bg-[#F9FAFB]' onClick={() => navigate(`/OrganizationManagement`, { replace: true })} />
            <p className='text-[#1D2939] m-0 font-[500] text-[14px]'>Back to organizations</p>
          </div>
        }
        userProfile={userProfile} />

      <div className='flex h-full'>
        {/* Left Panel   */}
        <div className='w-[220px] bg-white h-[calc(100vh-49px)] p-[10px] flex flex-col'>
          {loading ? (
            <Spinner />

          ) : (
            <>
              <Space className='!items-start'>
                <p className='text-[12px] text-[#667085]'>ORG:</p>
                <p className='text-[12px] text-[#667085]'>{orgDetails?.company_name || ""}</p>
              </Space>

              <div className='flex flex-col gap-y-[6px] flex-1 overflow-auto'>
                {brandList}
              </div>
            </>
          )}
          <div className='bg-gradient-to-tr from-[#B2DDFF] to-white rounded-[8px] p-[12px] mt-[10px]'>
            <p className='mb-[12px] text-[13px] font-[500]'>Want to add a new brand of yours?</p>
            <Button type='primary' onClick={() => navigate(`/createNewBrand/${params?.orgid}`)}>Add Brand</Button>
          </div>
        </div>

        {/* Right Panel  */}
        <div className='m-[16px] mb-0 w-[calc(100%-252px)]'>

          {/* Message Bar  */}
          {activeBrand && Object.keys(brandDetails).length > 0 && brandDetails?.status !== STATUS_APPROVED ? (
            <div className='w-full p-[20px] bg-[#FEDF89] flex items-center justify-between gap-x-[16px] mb-[16px] rounded-[8px]'>
              <div className='flex-1'>
                <p className='mb-[8px] text-[#93370D] text-[14px] font-[600]'>Action Required: Review Submission</p>
                <p className='m-0 text-[13px] text-[#344054]'>A submission from brand is pending your review.Please review all provided details and take the necessary action.</p>
              </div>
              <Button type='default' className='bg-white' onClick={() => setIsAddAsset(true)}>Request Files</Button>
              <Button type='primary' onClick={() => setConfirmApprove(true)}>Mark as Approved</Button>
            </div>
          ) : (
            <></>
          )}


          {/* Header Section */}
          <div className='bg-white rounded-[8px] p-[16px] w-full grid grid-cols-7 mb-[6px]'>
            {brandLoading ? (
              <div className='w-full col-span-7 h-[90px]'>
                <Spinner />
              </div>

            ) : (
              activeBrand && Object.keys(brandDetails).length > 0 ? (
                <>
                  <div className='col-span-2 flex gap-x-[12px] border-r border-[#E4E7EC] pr-[40px]'>
                    <Avatar style={{ backgroundColor: avatarBg(brandDetails?.brand_name?.charAt(0)) }}>{brandDetails?.brand_name?.charAt(0)}</Avatar>
                    <div>
                      <div className='flex items-center gap-x-[8px]'>
                        <p className='m-0 text-[#1D2939] text-[14px] font-[500] break-all'>{brandDetails?.brand_name}</p>
                        <Tag className='capitalize rounded-[12px] font-[500]' bordered={false} color={brandDetails?.status === STATUS_APPROVED ? 'success' : orgDetails?.is_active ? 'purple' : 'blue'}>{brandDetails?.status === STATUS_APPROVED ? "Approved" : orgDetails?.is_active ? "Activated" : brandDetails?.status?.toLowerCase()}</Tag>
                      </div>
                      <p className='mt-[4px] text-[#475467] text-[12px] mb-[4px]'>{brandDetails?.years_of_operation} • {formatAmount(brandDetails?.current_revenue)}</p>
                      {orgDetails?.website ? (
                        <div className='flex gap-x-[4px] items-center cursor-pointer' onClick={() => openLink(orgDetails?.website)}>
                          <LinkIcon />
                          <p className='max-w-[170px] truncate text-[12px] m-0 text-[#175CD3]'>{orgDetails?.website}</p>
                        </div>
                      ) : (
                        <></>
                      )}

                    </div>
                  </div>
                  <div className='col-span-2 flex flex-col gap-y-[20px] border-r border-[#E4E7EC] ml-[40px]  pr-[40px]'>
                    <div className='flex gap-x-[16px] items-center'>
                      <p className='text-[#475467] text-[12px] m-0'>Social:</p>
                      <Space>
                        {socialMediaLinks}
                      </Space>
                    </div>
                    <div className=''>
                      <p className='text-[#475467] text-[12px] mb-[8px]'>Marketplaces</p>
                      <div className='flex'>
                        {marketPlaces}
                      </div>
                    </div>
                  </div>
                  <div className='col-span-3 flex gap-y-[20px] ml-[40px]'>
                    <div className='flex flex-col gap-y-[20px] flex-1'>
                      <div className='flex gap-x-[16px] items-center'>
                        <p className='text-[#475467] text-[12px] m-0'>Country of Origin:</p>
                        <p className='text-[#1D2939] text-[12px] m-0 font-[500]'>{orgDetails?.region?.name}</p>
                      </div>
                      <div className=''>
                        <p className='text-[#475467] text-[12px] mb-[8px]'>Address</p>
                        <p className='text-[#1D2939] text-[12px] mb-[4px] font-[500]'>{orgDetails?.company_address_line1}</p>
                        <p className='text-[#1D2939] text-[12px] mb-[4px] font-[500]'>{orgDetails?.company_address_line2}</p>
                        <p className='text-[#1D2939] text-[12px] mb-[4px] font-[500]'>{orgDetails?.city}, {orgDetails?.state} - {orgDetails?.company_address_postal_code}</p>
                      </div>
                    </div>
                    <Dropdown menu={{ items: actionOptions }}>
                      <Button type='text' icon={<ThreeDotsIcon />} />
                    </Dropdown>
                  </div>
                </>
              ) : (
                <p className='text-[14px] text-[#475467] m-0 text-center col-span-7'>No Brand Selected!</p>
              )

            )}

          </div>

          {/* Tabs Section  */}
          {activeBrand && Object.keys(brandDetails).length > 0 ? (
            <Tabs items={items} color='#12B76A' animated activeKey={activeTab} onChange={(tab: string) => onChangeTab(tab)} />

          ) : (
            <></>
          )}

        </div>
      </div>
      <DeleteModal
        title="Brand"
        name={isDeleteItem?.brand_name}
        item={isDeleteItem}
        onCancel={() => setIsDeleteItem({})}
        onSuccess={() => onSuccessDeleteBrand()}
        api={SoftDeleteBrand}
      />

      <AddEditProductAssetModal
        brand={brandDetails}
        isProduct={false}
        open={isAddAsset}
        products={[]}
        editData={{}}
        onCancel={() => onCancelAddAsset()}
        onSuccess={(data: any) => onSuccessAddAsset(data)}
      />

      <ConfirmModal
        open={confirmApprove}
        onCancel={() => setConfirmApprove(false)}
        onOk={() => onConfirmApprove()}
        content={<>Are you sure you want to mark <strong>{brandDetails?.brand_name}</strong> as approved?</>}
        okText='Yes, Approve'
      />
    </div>
  )
}

export default OrganizationBrands